import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DataserviceService } from 'src/app/dataservice.service';
import { NzNotificationService } from 'ng-zorro-antd/notification';

@Component({
  selector: 'app-starlink-ihs-order',
  templateUrl: './starlink-ihs-order.component.html',
  styleUrl: './starlink-ihs-order.component.css'
})
export class StarlinkIhsOrderComponent {

  @Input() fullData: any;
  @Output() orderDone = new EventEmitter<{ ihsOrderNumber: string }>();

  orderForm: FormGroup;
  ihsUrl = '';
  loading = false;
  disclosures: string[] = [];
  disclosuresAccepted: boolean = false;
  currentUser: any;

  constructor(private fb: FormBuilder, private postData: DataserviceService, private notification: NzNotificationService) {
    this.orderForm = this.fb.group({
      ihsOrderNumber: [null, Validators.required],
      disclosuresAccepted: [false, Validators.requiredTrue]
    });
  }

  ngOnInit(): void {
    // console.log(this.fullData);
    this.currentUser = JSON.parse(localStorage.getItem('user') || '{}');
    this.loadIhsLink();
  }

  formatDisclosure(disclosure: string): string {
    return disclosure
      .replace(/<\/p>/gi, '\n\n')
      .replace(/<br\s*\/?>/gi, '\n')
      .replace(/<li>/gi, '\n- ')
      .replace(/<\/ul>/gi, '\n')
      .replace(/<[^>]+>/g, '')
      .replace(/&nbsp;/g, ' ')
      .replace(/&quot;/g, '"')
      .replace(/&#39;/g, "'")
      .replace(/&ldquo;/g, '"')
      .replace(/&rdquo;/g, '"')
      .replace(/\n{3,}/g, '\n\n')
      .trim();
  }

  loadIhsLink(): void {
    this.loading = true;
    let obj = {
      dishAccountId: '',
      agentId: this.currentUser.crm_id,
      starLinkConfirmation: this.fullData.starlinkOrder.starlinkOrderNumber,
      starLinkSerialNumber: this.fullData.catalog.reservedSku.sku
    }
    this.postData.postDataNoBodyDotBody(obj, 'starlink/ihs').subscribe((r: any) => {
      if (r?.result === 'success' && r?.data) {
        this.disclosures = r.data?.data?.disclosures?.map((d: any) => this.formatDisclosure(d.disclosure)) || [];
        this.ihsUrl = r.data?.data?.url || '';
      } else {
        this.notification.error('Error', r?.message?.message || 'Failed to load IHS link');
      }
      this.loading = false;
    }, e => {
      this.notification.error('Error', 'Failed to load IHS link');
      this.loading = false;
    })
  }

  openIhs(): void {
    if (this.ihsUrl) {
      window.open(this.ihsUrl, '_blank', 'noopener,noreferrer');
    }
  }

  submit(): void {
    // we need to call ihs endpoint to confirm and transition the sku to active, as well as the work order with a sale date
    if (this.orderForm.invalid) return;

    const ihsOrderNumber = this.orderForm.value.ihsOrderNumber;
    this.postData.postDataNoBodyDotBody(
      {
        woId: this.fullData.workOrderId,
        generic: { ihs_order_number: ihsOrderNumber }
      }, "starlink/finalize-order").subscribe((r: any) => {
        if(r?.result === 'success'){
          this.confirmSkuStatus();
          this.notification.success('Success', 'Order saved successfully');
          this.orderDone.emit({ ihsOrderNumber });
          this.loading = false;
        } else {
          this.notification.error('Error', r?.message?.message || 'Failed to save order');
          this.loading = false;
        }
      }, e => {
        this.notification.error('Error', 'Failed to save order');
        // console.log(e);
      })
  }

  confirmSkuStatus(): void {
    this.postData.postData({ sku: this.fullData.catalog.reservedSku.sku, status: 'active', woId: this.fullData.workOrderId }, 'starlink/updateSkuStatus').subscribe((r: any) => {
      if (r?.result === 'success') {
        this.notification.success('Success', 'SKU status updated successfully');
      } else {
        this.notification.error('Error', r?.message?.message || 'Failed to update SKU status');
      }
    });
  }
}